<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, kenwoodItalyBasicMixin],
  data: function() {
    return {};
  },
  mounted () {
    this.$el.style.setProperty("--evidence-stripe-color", this.evidenceStripe.background_color);
  },
  methods: {
  },
  computed: {
    evidenceStripe() {
      return this.content.evidence_stripe;
    },
    evidenceStripeStyle() {
      return {
        'background-color': this.evidenceStripe.background_color,
        'color': this.evidenceStripe.color 
      }
    }
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="[contentType, paddingY]" class="" v-if="isContentVisibleToUser()" two-col-evidence-component>
    <div class="container p-0" v-if="evidenceStripe">
      <p class="text-uppercase text-center py-2 evidence-text" :style="evidenceStripeStyle">{{ evidenceStripe.title }}</p>
      <div class="d-flex justify-content-center">
        <div class="triangle"></div>
      </div>
    </div>
    <stripe-two-col class="two-col-stripe" :content="content" :opt-container-content="containerContent"></stripe-two-col>
  </div>
</template>

<style lang="scss">
  [two-col-evidence-component] {
    
    .triangle {
      z-index: -1;
      position: relative;
      top: -2rem;
      width: 0;
      height: 0;
      border-top: 30px solid var(--evidence-stripe-color);
      border-left: 30px solid transparent;
      border-right: 30px solid transparent;
    }

    .two-col-stripe {
      position: relative;
      top: -3rem;
    }
  }

</style>
